import styled from 'styled-components';

export const StyledNameCell = styled.div`
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
`;

export const NumberCell = styled.div`
  font-family: var(--font-roboto-mono);
  padding: 10px 12px;
`;

export const SurpriseCell = styled.div<{
  $isPositive: boolean;
  $isZero: boolean;
}>`
  color: ${({ $isPositive, $isZero }) =>
    $isZero
      ? 'var(--text-soft)'
      : $isPositive
      ? 'var(--viz-bullish)'
      : 'var(--viz-bearish)'};
  background-color: ${({ $isPositive, $isZero }) =>
    $isZero
      ? 'var(--surface-default)'
      : $isPositive
      ? 'var(--viz-bullish-soft)'
      : 'var(--viz-bearish-soft)'};
  font-family: var(--font-roboto-mono);
  padding: 10px 12px;
`;
